import { useCesiumContext } from "../cesium/CesiumContext";
import { getEntityName } from "./TrackedEntityMenu";

import { ListItem, ListItemLabel, LabelTitle } from "../base/List";

import { Button } from "../base/Button";
import Tooltip from "../base/Tooltip";
import { TrashIcon } from "@radix-ui/react-icons";


type FeatureListItemLabelProps = {
    entityId: [string | undefined, string];
    className?: string;
    removeItem: (entityId: [string | undefined, string]) => void;
};
export const VisibilityEntityListItemLabel = ({
    entityId,
    className,
    removeItem
}: FeatureListItemLabelProps) => {

  const { map } = useCesiumContext();
  
  function getValue() {
    const entity = map.getEntity({datasourceId: entityId[0], entityId: entityId[1]});
    return entity ? getEntityName(entity) : "";     
  }

  return (
    <ListItemLabel
      className={className}
    >
      <LabelTitle>
          {getValue()}
      </LabelTitle>

    <Tooltip content="Ignore entity">
        <Button
            size="sq"
            variant="negative"
            isQuiet
            onPress={() => {
                removeItem(entityId);
              }
            }
            >
              <TrashIcon />
        </Button>
    </Tooltip>
    
    </ListItemLabel>
  );
};

type VisibilityEntityListItemProps = {
  entityId: [string | undefined, string];
  removeItem: (entityId: [string | undefined, string]) => void;
};
const VisibilityEntityListItem = ({
  entityId,
  removeItem
}: VisibilityEntityListItemProps) => {
  return (
    <ListItem>
      <VisibilityEntityListItemLabel
        entityId={entityId}
        removeItem={removeItem}
      />
    </ListItem>
  );
};

export default VisibilityEntityListItem;
